import React from 'react';
import BathtubSummary from './summary/BathtubSummary';
import DwdfSummary from './summary/DwdfSummary';
import WtSummary from './summary/WtSummary';
import KrwSummary from "./summary/KrwSummary";

const InquireQuotation = ({article}) => {
   const  renderSummary = (name) => {
        switch(name) {

            case 'bathtub':
                return <BathtubSummary />
            case 'dwdf':
                return <DwdfSummary />
            case 'wt':
                return <WtSummary />
            case 'krw':
                return <KrwSummary />

        }
    }

    return (
        <div id='summaryFull'>
            {renderSummary(article)}
        </div>
    )
};

export default InquireQuotation;



// WEBPACK FOOTER //
// ./src/components/download/additionalInfo/InquireQuotation.js